module.exports = __webpack_public_path__ + "img/icon-water-advanture.a5a779ef.svg";